"use client"

import { useEffect } from "react"

export function SourceTracker() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Detect source
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source')?.toLowerCase();
    const utmMedium = params.get('utm_medium')?.toLowerCase();

    let source = '';

    if (utmSource) {
      if (utmSource === 'facebook' || utmSource === 'meta' || utmSource === 'fb') {
        if (utmMedium === 'cpc' || utmMedium === 'ads' || utmMedium === 'paid') {
          source = 'META_ADS';
        } else {
          source = 'FACEBOOK';
        }
      } else if (utmSource === 'instagram' || utmSource === 'ig') {
        if (utmMedium === 'cpc' || utmMedium === 'ads' || utmMedium === 'paid') {
          source = 'META_ADS';
        } else {
          source = 'INSTAGRAM';
        }
      } else if (utmSource === 'tiktok' || utmSource === 'tt') {
        if (utmMedium === 'cpc' || utmMedium === 'ads' || utmMedium === 'paid') {
          source = 'TIKTOK_ADS';
        } else {
          source = 'TIKTOK';
        }
      }
    }

    if (!source) {
      const referrer = document.referrer?.toLowerCase();
      if (referrer) {
        if (referrer.includes('facebook.com')) {
          source = 'FACEBOOK';
        } else if (referrer.includes('instagram.com')) {
          source = 'INSTAGRAM';
        } else if (referrer.includes('tiktok.com')) {
          source = 'TIKTOK';
        }
      }
    }

    if (source) {
      sessionStorage.setItem('order_source', source);
    }
  }, []);

  return null;
}
